// iframe 向 父页面通信的 基础类
import BaseCommunicator from "./BaseCommunicator";
import {IIframeToParentCommunicator} from "./types";

export default class IframeToParentCommunicator extends BaseCommunicator implements IIframeToParentCommunicator {
  // 发送消息给父页面
  public sendToParent(type: string, payload?: unknown): void {
    if (!window.parent) {
      console.error('No parent window found');
      return;
    }
    
    window.parent.postMessage(
      { type, payload }, "*");
  }
}